

  <div [formGroup]="formGroupInput"
    [ngClass]="{'form-group col-xs-4 col-sm-8': !widgetSize,
      'form-group col-xs-8 col-sm-8': widgetSize}">
    <div [class.gb-input]="webu" [class.form-error]="showError()">

      @if (label) {
        <label class="hover" [class.gb-input-label]="webu" for="stateProvinceId">
          <span>{{label}}</span>
        </label>
      }
      
      <input 
        oxStateInput
        attr.aria-required="{{isAriaRequired}}"
        [oxFormatter]="validationType"
        [oxValidateHelper]="validationType"
        (focus)="onFocus()"
        [formControlName]="formControlNameInput"
        [formCtrlNameInput]="formControlNameInput"
        [ctrl]="formGroupInput"
        id="stateProvinceId"
        placeholder="{{placeHolderText}}"
        tabindex="0"
        type="alphaOnly"
        [class]="inputElClasses"
      />
    </div>
  </div>
  <div class="mt-5 ml-3 heavy" [class.gb-body1]="webu" id="stateLabel">
    {{stateLabel}}
  </div>

  @if (!showError()) {
    <div class="heavy mt-1 col-12" [class.gb-body2]="webu">

    @if (invalidStateCode && stateCode) {
      <span 
      [attr.aria-atomic]="true"
      class="error-message"
      [translate]="'signup_acctDetails_error_invalidStateCode'"
      role="alert"
    ></span>
    }
    
    @if (control.errors?.['required']) {
      <span
      [attr.aria-atomic]="true"
      class="error-message"
      [translate]="'error_required'"
      role="alert"
    ></span>
    }

  </div>  
  }
